import { Component, Input, OnInit } from '@angular/core';
import { SurveyApiService } from '../survey-api.service';

@Component({
  selector: 'survey-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

@Input() getsurveyelement: any;
@Input() getrestaurantaddress:any;
@Input() commentcardStyles: any;


image :any;

  constructor(public surveyService: SurveyApiService) {

   }

  ngOnInit() {
   // console.log(this.getsurveyelement)
   // let data = sessionStorage.getItem('getsurveyelement');
   // console.log(data);
  this.surveyService.imagedata.subscribe((data) => {
    this.image = data;
  })

  }

}
